// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1720141043870
      var cssReload = require("/usr/local/youhuiquan/coupon-ui-frontend-umi/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  